import $ from 'jquery';
import moment from 'moment';

// SUI calendar doesn't do a proper module export, so we need to shim it
import 'semantic-ui-calendar/dist/calendar.js';

export default () => {
  $.fn.calendarFr = function(params) {
    return $.fn.calendar.call(this, {
      firstDayOfWeek: 1,
      text: {
        days: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        months: [
          'Janvier',
          'Février',
          'Mars',
          'Avril',
          'Mai',
          'Juin',
          'Juillet',
          'Aout',
          'Septembre',
          'Octobre',
          'Novembre',
          'Décembre',
        ],
      },
      formatter: {
        hourHeader: date => moment(date).format('dddd DD'),
        datetime: date => {
          if (!date) {
            return '';
          }

          return moment(date).format('dddd DD MMMM YYYY à HH:mm');
        },
        time: date => moment(date).format('HH:mm'),
        ...params.formatter,
      },
      ...params,
    });
  };
};



// WEBPACK FOOTER //
// ./src/plugins/calendar.js